import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchMoyenPaiements } from "../../../store/actions/autreActions"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import { tableStyles } from "../../styles/tableStyles"
import Loader from "../../basics/Loader"
import MoyenPaiementModalV2 from "./MoyenPaiementModalV2"

const MODULES = [
	{ key: "showDep", label: "Dépannage" },
	{ key: "showAte", label: "Atelier" },
	{ key: "showLoc", label: "Location" },
]

const styles = {
	header: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginBottom: 16,
	},
	title: { fontSize: 15, fontWeight: 600, color: COLORS.text },
	count: { fontSize: 13, color: COLORS.textLight },
	empty: {
		...tableStyles.empty,
		padding: "40px 16px",
		color: COLORS.textLight,
		fontSize: 14,
	},
	typeChip: {
		display: "inline-flex",
		alignItems: "center",
		padding: "2px 9px",
		borderRadius: 99,
		fontSize: 11,
		fontWeight: 500,
		color: COLORS.accent,
		backgroundColor: COLORS.accentLight,
	},
	moduleCell: { display: "flex", flexWrap: "wrap", gap: 6 },
	moduleChip: {
		display: "inline-flex",
		alignItems: "center",
		padding: "2px 9px",
		borderRadius: 99,
		fontSize: 11,
		fontWeight: 500,
		color: COLORS.accent,
		backgroundColor: COLORS.accentLight,
	},
}

const formatValue = (mdp) =>
	mdp.isMult
		? `${mdp.value} %`
		: `${Number(mdp.value).toFixed(2)} CHF`

const MoyenRow = ({ mdp, index, onOpen }) => {
	const [hover, setHover] = useState(false)
	const bg = hover ? tableStyles.rowHover : tableStyles.rowBg(index)
	const modules = MODULES.filter((m) => mdp[m.key])
	return (
		<tr
			onDoubleClick={() => onOpen(mdp)}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			style={{
				backgroundColor: bg,
				cursor: "pointer",
				transition: "background-color 0.12s",
			}}
		>
			<td style={{ ...tableStyles.td, fontWeight: 500 }}>{mdp.nom || "—"}</td>
			<td style={tableStyles.td}>
				<span style={styles.typeChip}>
					{mdp.isMult ? "Multiplication" : "Addition"}
				</span>
			</td>
			<td style={tableStyles.td}>{formatValue(mdp)}</td>
			<td style={tableStyles.td}>
				<span
					style={gs.badge(
						mdp.apply ? COLORS.success : COLORS.textMuted,
						mdp.apply ? COLORS.successLight : COLORS.bg,
					)}
				>
					{mdp.apply ? "Oui" : "Non"}
				</span>
			</td>
			<td style={tableStyles.td}>
				{modules.length > 0 ? (
					<div style={styles.moduleCell}>
						{modules.map((m) => (
							<span key={m.key} style={styles.moduleChip}>
								{m.label}
							</span>
						))}
					</div>
				) : (
					"—"
				)}
			</td>
		</tr>
	)
}

// Onglet "Moyens de paiement" de la Configuration : table en lecture + édition
// par modal (double-clic / + Nouveau). Reprend les moyens de paiement de
// l'ancienne page /options dans le design V2.
const MoyensPaiementV2 = () => {
	const dispatch = useDispatch()
	const moyenPaiements = useSelector((s) => s.autreInfo.moyenPaiements)
	const fetchState = useSelector((s) => s.autreInfo.fetchMoyenPaiements)
	const [editing, setEditing] = useState(null) // moyen | null

	// Les moyens de paiement ne sont pas chargés app-wide → on les récupère ici.
	useEffect(() => {
		dispatch(fetchMoyenPaiements())
	}, [dispatch])

	const sorted = [...(moyenPaiements || [])].sort((a, b) =>
		(a.nom || "").localeCompare(b.nom || "", "fr"),
	)
	const loading = fetchState.loading && sorted.length === 0

	return (
		<>
			{editing && (
				<MoyenPaiementModalV2
					moyen={editing}
					onClose={() => setEditing(null)}
				/>
			)}
			<div style={styles.header}>
				<div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
					<span style={styles.title}>Moyens de paiement</span>
					<span style={styles.count}>{sorted.length}</span>
				</div>
				<button style={gs.btnPrimary} onClick={() => setEditing({})}>
					+ Nouveau moyen
				</button>
			</div>
			<div style={tableStyles.container}>
				{loading ? (
					<Loader variant="ring" message="Chargement…" />
				) : sorted.length === 0 ? (
					<div style={styles.empty}>Aucun moyen de paiement.</div>
				) : (
					<table style={tableStyles.table}>
						<thead>
							<tr>
								<th style={tableStyles.th}>Nom</th>
								<th style={tableStyles.th}>Type</th>
								<th style={tableStyles.th}>Valeur</th>
								<th style={tableStyles.th}>Applicable</th>
								<th style={tableStyles.th}>Modules</th>
							</tr>
						</thead>
						<tbody>
							{sorted.map((mdp, index) => (
								<MoyenRow
									key={mdp.id}
									mdp={mdp}
									index={index}
									onOpen={setEditing}
								/>
							))}
						</tbody>
					</table>
				)}
			</div>
		</>
	)
}

export default MoyensPaiementV2
